import classNames from "classnames";


export function SelectMenu(props) {
  const {
    onChange,
    label,
    value = '-1',
    options = [],
    placeholder = 'Choose an option',
    isDisabled = false,
    className = '',
    required = false,
    invalid = false,
    errorLabel = 'Please select an option'
  } = props;


  return (
    <label className={classNames(
      "font-semibold",
      {
        "text-red-600": invalid
      }
    )} >
      {label ? (<span> {label}</span >) : null}
      <select
        value={value}
        onChange={onChange ? (e) => onChange(e) : null}
        className={classNames(
          'block',
          'bg-transparent',
          'px-0',
          'py-2',
          'border-0',
          'border-b',
          'w-full',
          className,
          {
            'border-gray-darkest': !invalid,
            'border-red-600': invalid
          }
        )}
        required={required}>
        {
          [
            { value: "-1", label: placeholder },
            ...options,
          ].map((o, i) => (
            <option key={i} value={o.value}>{o.label}</option>
          ))
        }
      </select>
      {
        invalid ? (<span class="block font-normal italic mt-2 text-red-600 text-sm">{errorLabel}</span>) : null
      }
    </label >
  )
}